import {ChangeDetectionStrategy, Component, Inject, Optional} from "@angular/core";
import {generateMonthCalendarData, INT_MONTH_LIST_TOKEN, TCalendarCell} from "../../../shared";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {DateControllerStateDirective} from "../../directives";

@Component({
  selector: 'int-month-list',
  templateUrl: './int-month-list.component.html',
  styleUrls: ['./int-month-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntMonthListComponent {

  cells$: Observable<Array<TCalendarCell>> = this.controller?.changePluginState$
    .pipe(
      map((date) => {
        return date ? generateMonthCalendarData(date) : [];
      })
    )
  constructor(
    @Inject(INT_MONTH_LIST_TOKEN) readonly months: Array<string>,
    @Optional()
    @Inject(DateControllerStateDirective) private readonly controller: DateControllerStateDirective,
  ) {
  }

  get selectedDates() {
    return this.controller.onlyValidSelectDates();
  }

  get pluginState() {
    return this.controller.pluginDateStateForNavigation;
  }

  onSelect(date: Date) {
    this.controller.set(date);
  }
}
